var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInputAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90732 10.4306L5.18787 9.67045C5.24242 9.65212 5.29958 9.64274 5.35715 9.64258H9.64285C9.70042 9.6427 9.75758 9.65212 9.81213 9.67045L12.0927 10.4306C13.8299 11.0078 15.0017 12.6334 15 14.464C15 14.7599 14.7602 14.9998 14.4643 14.9998H0.535724C0.239846 14.9998 -1.90735e-06 14.7599 -1.90735e-06 14.464C-0.00166512 12.6334 1.17007 11.0078 2.90732 10.4306Z",
    fill: "#9197A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50007 0C9.27527 0 10.7144 1.43908 10.7144 3.21428V5.35715C10.7126 7.13163 9.27455 8.56967 7.50007 8.57143C5.72559 8.56967 4.28754 7.13163 4.28578 5.35715V3.21428C4.28578 1.43908 5.72487 0 7.50007 0Z",
    fill: "#9197A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInputAccount);
export default __webpack_public_path__ + "static/media/icon-input-account.5b21016c995282d9ee29c699647a3825.svg";
export { ForwardRef as ReactComponent };